/** True only when the URL query string contains themeswitch=yes. */
export function shouldShowThemeSwitcher(search: string): boolean {
  return new URLSearchParams(search).get('themeswitch') === 'yes';
}
